import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from 'Pods/Shared/Icon/Icon'

class CancelJobModal extends React.Component {
  constructor() {
    super()

    this.state = { isDisabledSubmit: false }

    this.cancelJob = this.cancelJob.bind(this)
    this.onModalClose = this.onModalClose.bind(this)
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this)
    this.onSubmitFailure = this.onSubmitFailure.bind(this)
  }

  cancelJob() {
    this.setState({ isDisabledSubmit: true })

    axios.put(`/api/internal/jobs/${this.props.id}/cancel`).then(this.onSubmitSuccess).catch(this.onSubmitFailure)
  }

  onSubmitSuccess() {
    App.events.publish('app:notification:flash:success', 'Project has been canceled successfully')
    setTimeout(() => window.location.href = '/profile/projects', 3000)
  }

  onSubmitFailure() {
    this.setState({ isDisabledSubmit: false })
    App.events.publish('app:notification:flash:error', 'Something went wrong, please try again')
  }

  onModalClose(e) {
    this.setState({ isDisabledSubmit: false })
    this.props.closeModal(e)
  }

  render() {
    return (
      <Modal
        isOpen={this.props.modalIsOpen}
        shouldCloseOnOverlayClick
        onRequestClose={this.onModalClose}
        contentLabel="Modal"
        ariaHideApp={false}
        className={{
          base: '',
          afterOpen: 'overlay-modal--container_after-open overlay-modal-container--xs',
          beforeClose: 'overlay-modal--container_before-close',
        }}
        overlayClassName={{
          base: 'overlay-modal--background',
          afterOpen: 'overlay-modal--background_after-open',
          beforeClose: 'overlay-modal--background_before-close',
        }}
      >
        <div className="overlay-modal" onClick={(e) => e.stopPropagation()}>
          <button className="btn btn-transparent overlay-modal--close-inner" onClick={this.onModalClose}>
            <Icon type={['fal', 'times']} color="grey-dark" />
          </button>
          <div className="overlay-modal--content overlay-modal--jobs">
            <div className="l-inner-large">
              <h2 className="modal-title">Cancel offer</h2>
              <p className="modal-description">
                Are you sure you want to cancel this Project?
              </p>
              <p className="modal-description">
                If you proceed, your Project will be terminated and archived – you will be able to review it later,
                but you will not be able to do anything else with it. The designer(s) will be notified about your
                decision to cancel the job. If you want to change some details of the job, you can do so by modifying
                the offer.
              </p>
              <p className="modal-description">
                If you still want to cancel the job, press the <b>Cancel Project</b> button below.
              </p>
              <div className="footer u-text-right u-mt10">
                <button className="btn btn-fat btn-outline-default" onClick={this.onModalClose}>Go back</button>
                <button
                  type="submit"
                  className="btn btn-fat btn-primary u-ml10"
                  disabled={this.state.isDisabledSubmit}
                  onClick={this.cancelJob}
                >
                  Cancel Project
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

CancelJobModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  modalIsOpen: PropTypes.bool,
}

CancelJobModal.defaultProps = {
  modalIsOpen: false,
}

export default CancelJobModal
